import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetRequest =
  ({ id, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.requests.get_one;
      const response = await PostFunction({
        data: {
          id: id,
        },
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageRequest =
  ({ callback, id, visa, status, expire_at, is_paid = null }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      bodyFormData.append("id", id);

      if (status) {
        bodyFormData.append("status", status);
      }
      if (expire_at) {
        bodyFormData.append("expire_at", expire_at);
      }
      if (
        visa &&
        visa != null &&
        visa != undefined &&
        ChackImageIsFile({ data: visa, IsBoolean: true })
      ) {
        bodyFormData.append("visa", visa);
      } else if (!visa) {
        bodyFormData.append("visa", "");
      }

      if (is_paid == 0 || is_paid == 1) {
        bodyFormData.append("is_paid", is_paid);
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: UrlApi.requests.update_request,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

// export const ManageCountries =
//   ({ callback, values, editMode }) =>
//   async (dispatch, getState) => {
//     try {
//       const noGroup =
//         CheckDataIfExit(values?.group_id) === false || values?.group_id === "-";

//       dispatch(setLoading(true));
//       var bodyFormData = new FormData();
//       if (editMode) {
//         bodyFormData.append("id", values?.id);
//       }
//       if (CheckDataIfExit(values?.name)) {
//         bodyFormData.append("name", values?.name);
//       }
//       if (CheckDataIfExit(values?.statistics)) {
//         bodyFormData.append("statistics", values?.statistics);
//       }
//       if (CheckDataIfExit(values?.visa_type)) {
//         if (noGroup) {
//           let visa_type_array = [];
//           for (let i = 0; i < values?.visa_type?.length; i++) {
//             visa_type_array.push(values?.visa_type[i].id);
//           }
//           bodyFormData.append("visa_type", JSON.stringify(visa_type_array));
//         }
//       }
//       // console.log({ grp_id: values?.group_id });
//       if (CheckDataIfExit(values?.group_id) && values?.group_id !== "-") {
//         bodyFormData.append("group_id", values?.group_id);
//       }
//       if (
//         values?.image &&
//         values?.image != null &&
//         values?.image != undefined &&
//         ChackImageIsFile({ data: values?.image, IsBoolean: true })
//       ) {
//         bodyFormData.append("image", values?.image);
//       } else if (editMode && !values?.image) {
//         bodyFormData.append("image", "");
//       }
//       const response = await PostFunction({
//         data: bodyFormData,
//         Route: editMode ? UrlApi.country.edit : UrlApi.country.add,
//         showalert: true,
//         state: getState,
//         isMultipart: true,
//         dispatch: dispatch,
//       });
//       dispatch(setLoading(false));
//       callback(response);
//     } catch (err) {
//       console.log(err);
//       dispatch(setLoading(false));
//       callback(false);
//     }
//   };

export const EditRequestReviews =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.request_reviews.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteRequestReviews =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idsrequestreviews: Array.isArray(id) ? id : [id],
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.request_reviews.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
